<template>
  <div class="" style="min-height: 150px">
    <div style="text-align: justify; overflow-wrap: break-word"
      v-if="!customView && !isExpedientesComponent && !isFormComponent && !isCentroDeSaludComponent">
      <div v-html="html"></div>
    </div>
    <div class="dinamic" v-if="customView">
      <component v-bind:is="customView"></component>
    </div>
    <GoogleFormIframe v-if="isVacunadenguesj" url="https://forms.gle/csfAaEoPDnDaciqR9" />
    <CentroDeSaludComponent v-if="isCentroDeSaludComponent" />
    <FormComponent v-if="isFormComponent" />
    <InfoBanner v-if="isInfoVacunasComponent" />
    <InfoGeneral v-if="informacionGeneral" />
    <InfoGeneral v-if="boletinesEpidemiologicos" title="Boletines Epidemiológicos" category="boletines-epidemiologicos" />
    <FichasEpidemiologicas v-if="fichasEpidemiologicas" />
    <ManipulacionAlimentos v-if="isManipulacionAlimentos" />
    <EmbedBot v-if="isBotComponent" />
    <DengueComponent v-if="isDengueComponent" />
    <ExpedientesComponent v-if="isExpedientesComponent" :filtros="{ site: 'dlc.siged.consulta.exp' }" />
    <!-- VISTA RESIDENCIAS -->
    <DetalleResidenciaComponent v-if="isBoxIconGridComponent" :filtros="{
      site: 'dlc.detalleResidenciaById.salud',
      id: obtenerID(),
    }" />
    <BoxIconGridComponent class="pt-3" v-if="isBoxIconGridComponent" titulo="Archivos Adjuntos" :filtros="{
      site: 'bigc.adjuntoResidenciaById.salud',
      id: obtenerID(),
    }" />
    <!-- FIN VISTA RESIDENCIAS -->

    <div class="text-center py-4">
      <p>
        <button v-on:click="back" class="btn btn-secondary text-uppercase">
          Volver
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ExpedientesComponent from "./components/resources/ExpedientesComponent.vue";
import FormComponent from "./components/resources/FormComponent.vue";
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import DetalleResidenciaComponent from "./components/resources/DetalleResidenciaComponent.vue";
import EmbedBot from "./components/resources/EmbedBot.vue"
import InfoBanner from "./components/resources/InfoBanner.vue"
import CentroDeSaludComponent from "./components/resources/CentroDeSaludComponent.vue"
import DengueComponent from "./components/resources/DengueComponent.vue";
import GoogleFormIframe from "./components/resources/GoogleFormIframe.vue";
import InfoGeneral from "./components/resources/InfoGeneral.vue";
import FichasEpidemiologicas from "./components/resources/FichasEpidemiologicas.vue";
import ManipulacionAlimentos from "./components/resources/ManipulacionAlimentos.vue";

export default {
  name: "InfoView",
  props: {
    uid: String,
    filtros: Object,
  },
  data() {
    return {
      html: null,
      customView: false,
      isExpedientesComponent: false,
      isFormComponent: false,
      isBoxIconGridComponent: false,
      isInfoVacunasComponent: false,
      idResidencia: "",
      isBotComponent: false,
      isCentroDeSaludComponent: false,
      isDengueComponent: false,
      isVacunadenguesj: false,
      informacionGeneral: false,
      boletinesEpidemiologicos: false,
      fichasEpidemiologicas: false,
      isManipulacionAlimentos: false
    };
  },
  methods: {
    obtenerID() {
      const idResidencia = this.uid.split("=")[1];
      return idResidencia;
    },
    back() {
      history.back();
    },
  },
  mounted() {
    if (this.uid === "CUMV-VIEW-FormComponent") {
      this.isFormComponent = true;
    } else if (this.uid === "CUMV-VIEW-ExpedientesComponent") {
      this.isExpedientesComponent = true;
    }
    else if (this.uid === "informacionGeneral") {
      this.informacionGeneral = true
    }
    else if (this.uid === "boletinesEpidemiologicos") {
      this.boletinesEpidemiologicos = true
    }
    else if (this.uid === "FichasEpidemiologicas") {
      this.fichasEpidemiologicas = true
    }
    else if (this.uid === "bot") {
      this.isBotComponent = true
    }
    else if (this.uid === "infoVacunas") {
      this.isInfoVacunasComponent = true
    }
    else if (this.uid === "manipulacionAlimentos") {
      this.isManipulacionAlimentos = true
    }
    else if (this.uid === "CUMV-VIEW-CentrosDeSalud") {
      this.isCentroDeSaludComponent = true
    }
    else if (this.uid === "dengue") {
      this.isDengueComponent = true
    }
    else if (this.uid === "vacunadenguesj") {
      this.isVacunadenguesj = true
    }
    else if (this.uid.includes("CUMV-"))
      switch (this.uid) {
        case "CUMV-centros-salud": {
          this.html = ``;
          break;
        }
      }
    else if (this.uid.includes("DETALLE-RESIDENCIA-ID=")) {
      this.isBoxIconGridComponent = true;
    } else {
      let params = {};
      if (this.filtros != null && this.filtros != "") {
        params = this.filtros;
      }
      params.uid = this.uid;

      axios
        .post(process.env.VUE_APP_API_URL, params)
        .then((response) => {
          this.html = response.data ? response.data.html : null;
          localStorage.setItem(this.uid, JSON.stringify(response));
        })
        .catch((error) => {
          if (!error.response) {
            console.log("Fuera de Linea");
            if (localStorage.getItem(this.uid)) {
              console.log("Cargando elementos de cache para " + this.uid);
              var resp = JSON.parse(localStorage.getItem(this.uid));
              this.html = resp.data ? resp.data.html : null;
            }
          }
        });
    }
  },
  components: {
    ExpedientesComponent,
    FormComponent,
    BoxIconGridComponent,
    DetalleResidenciaComponent,
    EmbedBot,
    InfoBanner,
    InfoGeneral,
    FichasEpidemiologicas,
    CentroDeSaludComponent,
    GoogleFormIframe,
    DengueComponent,
    ManipulacionAlimentos
  },
};
</script>
